import type { ILocaleType } from "@configs";

export const getDir = (lang: ILocaleType | string) => {
  if (lang === "en") {
    return "ltr";
  }
  return "rtl";
};
